// @ts-nocheck
import React, { createContext, useContext, ReactNode, useState, useMemo } from 'react';

interface AppState {
  chatUnreadCount: number;
}

interface UserContextType {
  user?: any;
  isLoading?: boolean;
  userProfile?: any;
  isProfileLoading?: boolean;
  appState: AppState;
  updateAppState: (updates: Partial<AppState>) => void;
  signIn?: (email: string, password: string) => Promise<void>;
  googleSignIn?: () => Promise<void>;
  preventNavigation?: boolean;
  currentTask?: string;
  progressiveState?: any;
  isInitialLoading?: boolean;
  progress?: number;
  addTask?: (task: any) => void;
  isReady?: boolean;
  averageNavigationTime?: number;
}

const defaultValue: UserContextType = {
  user: null,
  isLoading: false,
  userProfile: null,
  isProfileLoading: false,
  appState: { chatUnreadCount: 0 },
  updateAppState: () => {},
  signIn: async () => {},
  googleSignIn: async () => {},
  preventNavigation: false,
  currentTask: '',
  progressiveState: {},
  isInitialLoading: false,
  progress: 0,
  addTask: () => {},
  isReady: false,
  averageNavigationTime: 0,
};

const UserContext = createContext<UserContextType>(defaultValue);

export const useUser = (): UserContextType => {
  const context = useContext(UserContext);
  return context;
};

interface UserProviderProps {
  children: ReactNode;
}

export const UserProvider: React.FC<UserProviderProps> = ({ children }) => {
  const [appState, setAppState] = useState<AppState>({
    chatUnreadCount: 0,
  });

  const updateAppState = (updates: Partial<AppState>) => {
    setAppState(prev => ({ ...prev, ...updates }));
  };

  const value: UserContextType = useMemo(() => ({
    user: null,
    isLoading: false,
    userProfile: null,
    isProfileLoading: false,
    appState,
    updateAppState,
    signIn: async () => {},
    googleSignIn: async () => {},
    preventNavigation: false,
    currentTask: '',
    progressiveState: {
      stats: { reloadCount: 0, uptime: 0, message: '', averageNavigationTime: 0 },
      isPerformant: true,
      reloadCount: 0,
      uptime: 0,
      message: '',
      averageNavigationTime: 0
    },
    isInitialLoading: false,
    progress: 0,
    addTask: () => {},
    isReady: false,
    averageNavigationTime: 0,
  }), [appState, updateAppState]);

  return (
    <UserContext.Provider value={value}>
      {children}
    </UserContext.Provider>
  );
};